<script setup>
import { cn } from '@/lib/utils';

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <h3
    :class="
      cn('text-lg sm:text-xl md:text-xl font-bold text-slate-800 leading-none tracking-tight', props.class)
    "
  >
    <slot />
  </h3>
</template>
